/* Klaily — global theme JS
   Keep it tiny: header drawer + sticky shrink + reveal-on-scroll + cart count.
   Landing-page conversion logic (trio picker, ship meter, upsell) ships with
   the Trio template's own sections. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Mobile menu drawer ---- */
  var burger = document.querySelector('.header__burger');
  var drawer = document.getElementById('HeaderDrawer');
  if (burger && drawer) {
    burger.addEventListener('click', function () {
      var open = burger.getAttribute('aria-expanded') === 'true';
      burger.setAttribute('aria-expanded', String(!open));
      drawer.hidden = open;
    });
  }

  /* ---- Header dropdowns (caret toggles for touch + keyboard; hover is CSS) ---- */
  var carets = document.querySelectorAll('.header__caret');
  if (carets.length) {
    function closeAllMenus(except) {
      document.querySelectorAll('.header__navitem.is-open').forEach(function (item) {
        if (item === except) return;
        item.classList.remove('is-open');
        var c = item.querySelector('.header__caret');
        if (c) c.setAttribute('aria-expanded', 'false');
      });
    }
    carets.forEach(function (caret) {
      var item = caret.closest('.header__navitem');
      caret.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        caret.setAttribute('aria-expanded', String(open));
        if (open) closeAllMenus(item);
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.header__navitem')) closeAllMenus(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllMenus(null);
    });
  }

  /* ---- Slide-down search (predictive, no page jump) ---- */
  var sToggle = document.querySelector('[data-search-toggle]');
  var sPanel = document.getElementById('HeaderSearch');
  if (sToggle && sPanel) {
    var sInput = sPanel.querySelector('[data-search-input]');
    var sResults = sPanel.querySelector('[data-search-results]');
    var sClose = sPanel.querySelector('[data-search-close]');

    var onKeydown = function (e) {
      if (e.key === 'Escape') { closeSearch(); sToggle.focus(); }
    };
    var onDocClick = function (e) {
      if (!sPanel.contains(e.target) && !sToggle.contains(e.target)) closeSearch();
    };
    var openSearch = function () {
      sPanel.hidden = false;
      window.requestAnimationFrame(function () { sPanel.classList.add('is-open'); });
      sToggle.setAttribute('aria-expanded', 'true');
      if (sInput) window.setTimeout(function () { sInput.focus(); }, 80);
      document.addEventListener('keydown', onKeydown);
      document.addEventListener('click', onDocClick);
    };
    var closeSearch = function () {
      sPanel.classList.remove('is-open');
      sToggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKeydown);
      document.removeEventListener('click', onDocClick);
      if (reduceMotion) {
        sPanel.hidden = true;
      } else {
        var done = function () { sPanel.hidden = true; sPanel.removeEventListener('transitionend', done); };
        sPanel.addEventListener('transitionend', done);
      }
    };
    sToggle.addEventListener('click', function () {
      if (sToggle.getAttribute('aria-expanded') === 'true') closeSearch(); else openSearch();
    });
    if (sClose) sClose.addEventListener('click', function () { closeSearch(); sToggle.focus(); });

    if (sInput && sResults) {
      var esc = function (str) {
        return String(str).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      };
      var group = function (title, inner) {
        return '<div class="header__search-group"><p class="header__search-grouptitle">' + title + '</p>' + inner + '</div>';
      };
      var render = function (q, res) {
        var html = '';
        if (res.products && res.products.length) {
          html += group('Products', res.products.map(function (p) {
            var thumb = p.image
              ? '<img class="header__search-thumb" src="' + p.image + '" alt="" loading="lazy" width="44" height="44">'
              : '<span class="header__search-thumb"></span>';
            return '<a class="header__search-item" href="' + p.url + '">' + thumb +
              '<span class="header__search-itemtitle">' + esc(p.title) + '</span></a>';
          }).join(''));
        }
        var pages = (res.pages || []).concat(res.articles || []);
        if (pages.length) {
          html += group('Pages & posts', pages.map(function (p) {
            return '<a class="header__search-item" href="' + p.url + '"><span class="header__search-itemtitle">' + esc(p.title) + '</span></a>';
          }).join(''));
        }
        if (html) {
          html += '<a class="header__search-all" href="/search?q=' + encodeURIComponent(q) + '">See all results</a>';
        } else {
          html = '<p class="header__search-empty">No matches for “' + esc(q) + '”. Press Enter to search everything.</p>';
        }
        sResults.innerHTML = html;
        sResults.hidden = false;
      };
      var debounce;
      sInput.addEventListener('input', function () {
        var q = sInput.value.trim();
        window.clearTimeout(debounce);
        if (q.length < 2) { sResults.hidden = true; sResults.innerHTML = ''; return; }
        debounce = window.setTimeout(function () {
          var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product,page,article&resources[limit]=5&resources[options][unavailable_products]=last';
          fetch(url, { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (data) { render(q, data.resources.results); })
            .catch(function () { /* form submit still works as fallback */ });
        }, 220);
      });
    }
  }

  /* ---- Sticky header: compact + shadow once scrolled past a threshold ---- */
  var header = document.querySelector('.header[data-sticky-header]');
  if (header) {
    var THRESHOLD = 24;
    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        header.classList.toggle('header--scrolled', window.scrollY > THRESHOLD);
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Smooth height expand/collapse (grid-rows technique) ----
     One engine, shared by the FAQ section and the product page's collapsible
     rows. Animates grid-template-rows 0fr↔1fr and only flips the native [open]
     attribute at the end of a collapse, so the height transition never snaps. */
  function bindAccordion(item, summary, wrap) {
    if (item.open) item.classList.add('is-open');

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (item.dataset.animating === '1') return;

      if (reduceMotion) {
        item.open = !item.open;
        item.classList.toggle('is-open', item.open);
        return;
      }

      if (item.open) {
        // Collapse: animate to 0fr, then drop the [open] attribute at the end.
        item.dataset.animating = '1';
        item.classList.remove('is-open');
        var onCollapse = function (ev) {
          if (ev.target !== wrap || ev.propertyName !== 'grid-template-rows') return;
          item.open = false;
          item.dataset.animating = '';
          wrap.removeEventListener('transitionend', onCollapse);
        };
        wrap.addEventListener('transitionend', onCollapse);
      } else {
        // Expand: reveal content, force reflow, then animate to 1fr.
        item.open = true;
        item.dataset.animating = '1';
        void wrap.offsetHeight;
        item.classList.add('is-open');
        var onExpand = function (ev) {
          if (ev.target !== wrap || ev.propertyName !== 'grid-template-rows') return;
          item.dataset.animating = '';
          wrap.removeEventListener('transitionend', onExpand);
        };
        wrap.addEventListener('transitionend', onExpand);
      }
    });
  }
  [
    ['.faq__item', '.faq__q', '.faq__a-wrap'],
    ['.mp__acc', '.mp__acc-q', '.mp__acc-a-wrap']
  ].forEach(function (cfg) {
    document.querySelectorAll(cfg[0]).forEach(function (item) {
      var summary = item.querySelector(cfg[1]);
      var wrap = item.querySelector(cfg[2]);
      if (summary && wrap) bindAccordion(item, summary, wrap);
    });
  });

  /* ---- Reveal-on-scroll (progressive enhancement) ---- */
  var inEditor = !!(window.Shopify && window.Shopify.designMode);
  function revealNow(el) { el.classList.add('is-visible'); }
  function setupReveals(root) {
    var els = (root || document).querySelectorAll('.reveal');
    // In the theme editor (or reduced-motion / no IO support) show everything
    // immediately — otherwise re-rendered sections would stay invisible.
    if (inEditor || reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(revealNow);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { revealNow(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) {
      // Anything already on-screen reveals immediately (no waiting on the observer).
      if (el.getBoundingClientRect().top < window.innerHeight) { revealNow(el); }
      else { io.observe(el); }
    });
    // Fail-safe: content must never stay hidden. If the observer hasn't fired for
    // an element that's since entered view, reveal it; after 4s reveal everything.
    var failsafe = function () {
      els.forEach(function (el) {
        if (!el.classList.contains('is-visible') && el.getBoundingClientRect().top < window.innerHeight + 200) { revealNow(el); }
      });
    };
    window.addEventListener('scroll', failsafe, { passive: true });
    setTimeout(function () { els.forEach(revealNow); window.removeEventListener('scroll', failsafe); }, 4000);
  }
  setupReveals(document);

  /* ---- Theme editor: re-injected sections aren't seen by the observer ---- */
  if (inEditor) {
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('.reveal').forEach(revealNow);
    });
  }

  /* ---- Momentum smooth scrolling (self-built, ~1KB) ----
     Eases wheel scrolling for a gliding feel. Skips: touch devices, reduced
     motion, the theme editor, nested scrollables (cart drawer, dropdowns), and
     locked-scroll states. Anchor links glide through the same easing. */
  (function () {
    if (reduceMotion || inEditor) return;
    if (!window.matchMedia('(pointer: fine)').matches) return; // desktop pointer only

    var target = window.scrollY;
    var currentY = target;
    var running = false;
    var EASE = 0.1;

    // We drive scroll per-frame, so native CSS smooth-scroll must be off.
    document.documentElement.style.scrollBehavior = 'auto';

    function maxScroll() { return Math.max(0, document.documentElement.scrollHeight - window.innerHeight); }
    function clamp(v) { return Math.max(0, Math.min(v, maxScroll())); }

    function frame() {
      currentY += (target - currentY) * EASE;
      if (Math.abs(target - currentY) < 0.4) {
        currentY = target;
        window.scrollTo(0, currentY);
        running = false;
        return;
      }
      window.scrollTo(0, currentY);
      requestAnimationFrame(frame);
    }
    function start() { if (!running) { running = true; currentY = window.scrollY; requestAnimationFrame(frame); } }

    // Let an inner scrollable (cart drawer, filter dropdown) keep native scroll.
    function nestedScrollable(node, dir) {
      while (node && node !== document.body && node !== document.documentElement) {
        if (node.nodeType === 1 && node.scrollHeight > node.clientHeight) {
          var oy = getComputedStyle(node).overflowY;
          if (oy === 'auto' || oy === 'scroll') {
            if (dir > 0 && node.scrollTop + node.clientHeight < node.scrollHeight - 1) return true;
            if (dir < 0 && node.scrollTop > 1) return true;
          }
        }
        node = node.parentNode;
      }
      return false;
    }

    window.addEventListener('wheel', function (e) {
      if (e.ctrlKey) return;                                   // pinch-zoom
      if (maxScroll() <= 0) return;                            // nothing to scroll
      if (document.documentElement.style.overflow === 'hidden') return; // drawer open
      if (nestedScrollable(e.target, e.deltaY)) return;
      e.preventDefault();
      var d = e.deltaY;
      if (e.deltaMode === 1) d *= 16; else if (e.deltaMode === 2) d *= window.innerHeight;
      if (!running) target = window.scrollY;
      target = clamp(target + d);
      start();
    }, { passive: false });

    // Keep target synced when the user scrolls by keyboard / scrollbar.
    window.addEventListener('scroll', function () { if (!running) { target = window.scrollY; currentY = window.scrollY; } }, { passive: true });

    // In-page anchor links glide too.
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href.length < 2) return;
      var el = document.getElementById(href.slice(1));
      if (!el) return;
      e.preventDefault();
      target = clamp(el.getBoundingClientRect().top + window.scrollY - 80);
      start();
    });
  })();

  /* ---- Cart count refresh (so the header stays accurate after AJAX adds) ---- */
  window.klailyRefreshCart = function () {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        return cart;
      })
      .catch(function () {});
  };
})();
